import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_131: FaireProductEntity = {
  token: "legacy_prod_abbott-131",
  type: "product",
  name: "Blue & Ivory Printed Floor Rug",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8866cd87a5aba5f526f61e538f3c0d5babe265f3d8e52ff098f0c3ea6febfa52.jpeg",
  priceDollars: 89,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
